define.alias("shared/components/shared/ui/search-box/results", "media/components/shared/ui/search-box/results");